import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { updateCustomRule } from '../../../api_methods'

// Campo testo che consente l'impostazione del valore di una lingua per una regola
function LanguageField({ rule, disabled, ratio }) {
  const [val, setVal] = useState(rule.tag_en ? rule.tag_en : '')
  const [invalidTag, setInvalidTag] = useState(false)

  useEffect(() => {
    // Quando cambia l'indice sincronizzo
    setVal(rule.tag_en ? rule.tag_en : '')
  }, [rule.id])

  const handleBlur = () => {
    // Creo un piccolo dict per mandare i dati a backend
    const data = {tag_en: val}

    // Aggiorno il valore per il frontend
    rule.tag_en = val

    // Salva a backend il valore in un campo della json_rule che ha come chiave il nome della lingua, sull'onblur
    if(!invalidTag) updateCustomRule(rule.id, data)
  }

  const handleVal = (event) => {
    // Tags should not have "," inside
    if (event.target.value.includes(',')){
      setInvalidTag(true);
    } else if(val.includes(',') && !event.target.value.includes(',')){
      setInvalidTag(false);
    }
    setVal(event.target.value)
  }

  return (
    <div style={{ display: 'inline-block', width: ratio.tag }}>
      <fieldset className="w-seo-control-field">
        <Form.Control
          type="text"
          title={'nome'}
          value={val}
          disabled={disabled}
          onChange={handleVal}
          onBlur={handleBlur}
          isInvalid={invalidTag}
          className="form-control"
        />
      </fieldset>
    </div>
  )
}

// Componente per le singole righe di una lingua (sono in pratica una traduzione del value di una regola in un'altra lingua)
// Crea tanti field quante sono le lingue selezionati
export function LanguageRow({
  showLanguages,
  rule,
  disabled,
  ratio,
}) {
  return (
    <>
      {showLanguages && (<LanguageField rule={rule} disabled={disabled} ratio={ratio} />)}
    </>
  )
}
